<div :class="{'bg-red-100' : data.dibatalkan}" class="p-2">
    <div class="text-center text-xl font-bold">{{app_base_data.company_name}}</div>
    <div class="text-center mt-2"><b>Antrian Rawat Jalan</b></div>
    <div v-if="data.jam && !data.dibatalkan" class="text-center  font-italic text-base">
        Silahkan Datang Jam {{data.jam}}
    </div>
    <div class="text-center font-bold text-7xl">{{data.antrian_poli}}</div>
    
    <!--------------------------------------------------------------------->
    <div v-if="data.dibatalkan">
        <div class="text-center font-bold text-2xl">DIBATALKAN</div>
        <div class="text-center font-bold font-italic text-sm mt-2">
            Dibatalkan Oleh : {{data.dibatalkan.cancel_by}}
        </div>
        <div class="text-center font-bold font-italic text-sm mt-2">
            Dibatalkan Pada : {{data.dibatalkan.cancel_at}}
        </div>
        <div class="text-center font-bold font-italic text-sm mt-2">
            keterangan : {{data.dibatalkan.keterangan}}
        </div>
    </div>
    <!--------------------------------------------------------------------->
    <div v-else>
        <div class="text-center">--( {{data.antrian_admin}} )--</div>
        <div class="text-center font-bold text-base">
            {{data.tgl_pemeriksaan}} - ({{data.penjamin}}) <br>
            {{data.nama_poli}}
        </div>

        <div v-if="data.dokter"  class="text-center text-base font-italic">
            {{data.dokter}}
        </div>
        
        <div class="text-center font-bold font-italic text-sm mt-2">
            RM : {{data.nomor_rm}} <br>
            <span v-if="data.kode_bpjs && data.penjamin == 'BPJS'">BPJS : {{data.kode_bpjs}} <br></span>
            {{data.nama}} <br>
        </div>
        
        <div v-if="data.finger.status" class="text-center  font-italic text-base">
            {{data.finger.msg}}
        </div>

        <div v-if="data.jam && !data.dibatalkan" class="text-center  font-italic text-base">
            dimohon datang tepat waktu!!
        </div>
        
        <div v-if="data.sumber" class="text-center  font-italic text-sx">
            by {{data.sumber}}
        </div>
    </div>
    <!--------------------------------------------------------------------->
    
</div>